import { render, staticRenderFns } from "./FilePicker.vue?vue&type=template&id=560b0bf1&shadow"
import script from "./FilePicker.vue?vue&type=script&lang=js&shadow"
export * from "./FilePicker.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports